const SET_LIST = (state, obj) => {
  state.list = obj
}

const SET_TEMPLATE_CONTRACT_OPTIONS = (state, obj) => {
  state.contractTemplateOptions = obj
}

const SET_CURRENT_ASSIGNOR = (state, obj) => {
  state.current = obj
}

const SET_ERRORS = (state, obj) => {
  state.errors = { ...obj }
}

const SET_ASSIGNOR = (state, obj) => {
  // WARNING! Assim garantimos que qualquer chave ja existente em state.assignor não seja removida, somente sobrescrevendo os valores das chaves necessárias
  Object.assign(state.assignor, obj)
}

const RESET_ASSIGNOR = (state) => {
  state.assignor = JSON.parse(JSON.stringify(state.initalAssignor))
}

const RESET_ERRORS = (state) => {
  state.errors = { ...state.initialErrors }
}

const RESET_ERRORS_DOCS = (state) => {
  state.errors.docs = []
}

const UPDATE_VALUES = (state, obj) => {
  Object.assign(state.assignor, obj)
}

export default {
  SET_LIST,
  SET_CURRENT_ASSIGNOR,
  SET_ERRORS,
  SET_ASSIGNOR,
  RESET_ASSIGNOR,
  RESET_ERRORS,
  UPDATE_VALUES,
  SET_TEMPLATE_CONTRACT_OPTIONS,
  RESET_ERRORS_DOCS
}



// WEBPACK FOOTER //
// ./src/features/assignors/store/mutations.js